export interface Report {
  id: string;
  title: string;
  type: string;
  site: string;
  status: "draft" | "in-review" | "complete" | "submitted";
  createdAt: string;
  updatedAt: string;
  assignee: string;
}

export interface Site {
  id: string;
  name: string;
  address: string;
  city: string;
  state: string;
  status: "active" | "pending" | "completed" | "archived";
  projectCount: number;
  lastActivity: string;
}

export interface FieldReading {
  id: string;
  site: string;
  type: "voc" | "air" | "weather" | "video";
  value: string;
  unit: string;
  timestamp: string;
  status: "normal" | "warning" | "alert";
}

export interface ActivityItem {
  id: string;
  action: string;
  subject: string;
  timestamp: string;
  user: string;
}

export const mockReports: Report[] = [
  { id: "RPT-001", title: "Phase I ESA – Riverside Industrial Park", type: "Phase 1 ESA", site: "Riverside Industrial Park", status: "in-review", createdAt: "2026-02-15", updatedAt: "2026-03-06", assignee: "J. Martinez, PE" },
  { id: "RPT-002", title: "Phase I ESA – Oak Street Redevelopment", type: "Phase 1 ESA", site: "Oak Street Lot", status: "draft", createdAt: "2026-03-01", updatedAt: "2026-03-07", assignee: "S. Chen, PE" },
  { id: "RPT-003", title: "Phase II ESA – Harbor Point Marina", type: "Phase 2 ESA", site: "Harbor Point Marina", status: "complete", createdAt: "2026-01-10", updatedAt: "2026-02-28", assignee: "J. Martinez, PE" },
  { id: "RPT-004", title: "Remedial Action Plan – Former Gas Station", type: "RAP", site: "Elm & 5th Former Station", status: "submitted", createdAt: "2025-11-20", updatedAt: "2026-01-15", assignee: "A. Patel, PE" },
  { id: "RPT-005", title: "Phase I ESA – Greenfield Commons", type: "Phase 1 ESA", site: "Greenfield Commons", status: "draft", createdAt: "2026-03-05", updatedAt: "2026-03-08", assignee: "S. Chen, PE" },
];

export const mockSites: Site[] = [
  { id: "SITE-001", name: "Riverside Industrial Park", address: "1200 River Rd", city: "Portland", state: "OR", status: "active", projectCount: 3, lastActivity: "2026-03-06" },
  { id: "SITE-002", name: "Oak Street Lot", address: "450 Oak St", city: "Seattle", state: "WA", status: "active", projectCount: 1, lastActivity: "2026-03-07" },
  { id: "SITE-003", name: "Harbor Point Marina", address: "88 Harbor Blvd", city: "San Diego", state: "CA", status: "completed", projectCount: 2, lastActivity: "2026-02-28" },
  { id: "SITE-004", name: "Elm & 5th Former Station", address: "500 Elm St", city: "Denver", state: "CO", status: "active", projectCount: 1, lastActivity: "2026-01-15" },
  { id: "SITE-005", name: "Greenfield Commons", address: "2100 Greenfield Dr", city: "Austin", state: "TX", status: "pending", projectCount: 1, lastActivity: "2026-03-08" },
];

export const mockFieldReadings: FieldReading[] = [
  { id: "FR-001", site: "Riverside Industrial Park", type: "voc", value: "2.4", unit: "ppm", timestamp: "2026-03-08 08:30", status: "normal" },
  { id: "FR-002", site: "Riverside Industrial Park", type: "air", value: "45", unit: "µg/m³", timestamp: "2026-03-08 08:30", status: "normal" },
  { id: "FR-003", site: "Riverside Industrial Park", type: "weather", value: "52°F / 78% RH", unit: "", timestamp: "2026-03-08 08:30", status: "normal" },
  { id: "FR-004", site: "Elm & 5th Former Station", type: "voc", value: "18.7", unit: "ppm", timestamp: "2026-03-08 07:45", status: "alert" },
  { id: "FR-005", site: "Elm & 5th Former Station", type: "air", value: "120", unit: "µg/m³", timestamp: "2026-03-08 07:45", status: "warning" },
];

export const mockActivity: ActivityItem[] = [
  { id: "ACT-001", action: "Updated report", subject: "Phase I ESA – Riverside Industrial Park", timestamp: "2 hours ago", user: "J. Martinez" },
  { id: "ACT-002", action: "Uploaded document", subject: "Site plan – Oak Street Lot", timestamp: "4 hours ago", user: "S. Chen" },
  { id: "ACT-003", action: "Field alert triggered", subject: "VOC reading exceeded threshold at Elm & 5th", timestamp: "5 hours ago", user: "System" },
  { id: "ACT-004", action: "Report submitted", subject: "RAP – Former Gas Station", timestamp: "1 day ago", user: "A. Patel" },
  { id: "ACT-005", action: "New site registered", subject: "Greenfield Commons", timestamp: "3 days ago", user: "S. Chen" },
];

export const statusColors: Record<string, string> = {
  draft: "bg-muted text-muted-foreground",
  "in-review": "bg-warning/15 text-warning",
  complete: "bg-success/15 text-success",
  submitted: "bg-info/15 text-info",
  active: "bg-success/15 text-success",
  pending: "bg-warning/15 text-warning",
  completed: "bg-muted text-muted-foreground",
  archived: "bg-muted text-muted-foreground",
  normal: "bg-success/15 text-success",
  warning: "bg-warning/15 text-warning",
  alert: "bg-destructive/15 text-destructive",
};
